import { Inject, Injectable } from '@angular/core';
import {
  Credits_Log,
  DatasService,
  GetAllInstitutionsByExamGQL,
  GetRegistrationBillingsGQL,
  GetRegistrationsGQL,
  Institutions,
  Profiles,
  Registration_Billings,
  Registrations
} from '@polylearn/models';
import { flatten } from 'lodash';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  angularJsAPI;

  constructor(
    private getAllInstitutionsByExamGQL: GetAllInstitutionsByExamGQL,
    private getRegistrationsGQL: GetRegistrationsGQL,
    private getRegistrationBillingsGQL: GetRegistrationBillingsGQL,
    private dataService: DatasService,
    @Inject('api') api: any,
    private router: Router
  ) {
    this.angularJsAPI = api;
  }

  public getInstitutionByExam(): Observable<Institutions[]> {
    return this.getAllInstitutionsByExamGQL
      .fetch(
        {
          exam: environment.EXAM
        },
        {
          fetchPolicy: 'no-cache',
          context: {
            headers: {
              role: 'limitedAdmin'
            }
          }
        }
      )
      .pipe(
        take(1),
        map(res => (res.data.institutions as any) as Institutions[])
      );
  }

  public getRegistrations(): Observable<Registrations[]> {
    return this.getRegistrationsGQL
      .fetch(
        {},
        {
          fetchPolicy: 'no-cache',
          context: {
            headers: {
              role: 'limitedAdmin'
            }
          }
        }
      )
      .pipe(
        take(1),
        map(res => (res.data.registrations as any) as Registrations[])
      );
  }

  public getRegistrationBillings(): Observable<Registration_Billings[]> {
    return this.getRegistrationBillingsGQL
      .fetch(
        {},
        {
          fetchPolicy: 'no-cache',
          context: {
            headers: {
              role: 'limitedAdmin'
            }
          }
        }
      )
      .pipe(
        take(1),
        map(
          res =>
            (res.data.registration_billings as any) as Registration_Billings[]
        )
      );
  }

  public getCreditsLog(): Observable<Credits_Log[]> {
    return this.getInstitutionByExam().pipe(
      map(res => flatten(res.map(institution => institution.credits_logs)))
    );
  }

  public async go(
    newInstitutionId: number,
    role: 'limitedAdmin' | 'manager' = 'limitedAdmin',
    is_guest: boolean = false
  ) {
    let me = await this.angularJsAPI.me();

    this.dataService
      .updateData$<Profiles>(
        'profiles',
        role,
        me.profile.id,
        {
          institution_id: newInstitutionId,
          is_guest
        },
        'id'
      )
      .subscribe(async () => {
        await this.angularJsAPI.sync(this.angularJsAPI.me);

        setTimeout(() => {
          this.router.navigateByUrl('/');
          // location.reload();
        }, 1000);
      });
  }
}
